import React, { Component } from 'react';
import Layout from './Common/layout/index';
import * as appConfig from './Common/config/app-brand-config.json';
import commonStore from './Common/stores/commonStore';

class App extends Component {

  componentDidMount() {
    // When executing an application hosted on the Availity platform,
    // we need to get information regarding who is logged in as well as brand and session information.
    // This data is only retrieved one time per session and will be captured and stored in the commonStore.
    // Each user within Availity has a default state they are associated with which is used to (TODO - complete comment)
    this.startup();
  }

  startup = async () => {
    commonStore.appName = appConfig.appName;
    // commonStore.appVersion = appConfig.appVersion;
    // GETUSER
    // When interacting with an application hosted on the Availity platform, we need to get information regarding
    // the current session's logged in user
    // const getUserResponse = await getUserApi();
    // this.processUserApiResponse(getUserResponse);

    // GETREGION
    // When interacting with an application hosted on the Availity platform, we need to get information regarding
    // the current session's brand information. The information returned from Availity includes:
    // SessionID such as '73162546201455907487472200000710'
    // code such as 'AGP'
    // app such as 'AMERIGROUP'
    // payerName such as 'AMERIGROUP'
    // logoUrl - the static location of the logo to be displayed on the screen
    // isMultiBrand - true when the application is used with multiple brands.
    // default - contains the default brand information. Useful when isMultiBrand is set to true
    // const getRegionReponse = await getRegionApi();
    // this.processRegionApiResponse(getRegionReponse);
    // GETDISCLAIMER
    // Anthem's service call takes the following:
    // brand code such as ''
    // state such as ''
    // applicationId such as '10006'
    // these parameters are passed to service's utilities/disclaimer method which returns the disclaimer or Terms Of Use info
    // changed display from 'block' to 'none' to hide Disclaimer on UI...
    // if (commonStore.disclaimer.showBlock && commonStore.callDisclaimer) {
    //   const stateBrand = appConfig.disclaimer.state[commonStore.brand.state];
    //   if (typeof stateBrand !== 'undefined') {
    //     if (stateBrand.brand === commonStore.brand.code) {
    //       const getDisclaimerReponse = await getDisclaimer();
    //       this.processDisclaimerResponse(getDisclaimerReponse);
    //     }
    //   }
    // }

    // GETTERMSOFUSE
    // Anthem's service call takes the following:
    // brand code such as ''
    // state such as ''
    // applicationId such as '10006'
    // these parameters are passed to service's utilities/disclaimer method which returns the disclaimer or Terms Of Use info
    // commonStore.termsOfUse.showBlock = appConfig.termsOfUse.showBlock;
    // if (commonStore.termsOfUse.showBlock) {
    //   const stateBrand = appConfig.termsOfUse.state[commonStore.brand.state];
    //   if (typeof stateBrand !== 'undefined') {
    //     if (stateBrand.brand === commonStore.brand.code) {
    //       const getTermsOfUseReponse = await getTermsOfUse();
    //       this.processTermsOfUseResponse(getTermsOfUseReponse);
    //     }
    //   }
    // }
  };

  // processUserApiResponse(response) {
  //   const user = {
  //     id: response.id,
  //     email: response.email,
  //     firstName: response.firstName,
  //     lastName: response.lastName,
  //     userId: response.userId,
  //     akaname: response.akaname,
  //   };
  //   commonStore.user = user;
  //   // The interactionId is used during transaction logging in order to differentiate which logs belong to which session when the same user is logged in
  //   commonStore.user.interactionId = hashcode.getHashCode(commonStore.user.id + new Date().getTime());
  // }

  // processRegionApiResponse(response) {
  //   const queryString = url.search();
  //   // The spaceId, which is also the SessionID, is passed in the queryString when interacting with the Availity application
  //   let { spaceId } = queryString;
  //   const { state } = response[0];
  //   if (!spaceId) {
  //     spaceId = Object.keys(brandConfig.default[state])[0];
  //     // spaceId = brandConfig[state].default.spaceId;
  //   }
  //   if (brandConfig.default[state] && brandConfig.default[state].isMultiBrand) {
  //     commonStore.brand = brandConfig.default[state][spaceId];
  //     if (!commonStore.brand) {
  //       commonStore.brand = brandConfig.default[state].default;
  //     }
  //   } else {
  //     commonStore.brand = brandConfig.default[state];
  //   }
  //   commonStore.brand.spaceId = spaceId;
  //   commonStore.brand.state = state;
  //   // changed below value form true to false to stop disclaimer call...
  //   commonStore.callDisclaimer = true;
  //   // call spaceapi for brand logo URL
  //   async function callSpace() {
  //     const responseSpace = await getSpacesApi(commonStore.brand.spaceId);
  //     commonStore.brand.logoURL = responseSpace;
  //     commonStore.spaceLogoUrl = responseSpace;
  //   }
  //   // uncomment below function call to call space api
  //   // callSpace();
  // }

  // set Disclaimer content
  // processDisclaimerResponse(response) {
  //   if (response.data.disclaimerInfo && response.data.disclaimerInfo.component) {
  //     const disclaimerInfo = response.data.disclaimerInfo.component.disclaimer;
  //     commonStore.disclaimer.content = disclaimerInfo;
  //   }
  // }

  // set TermsOfUse content
  // processTermsOfUseResponse(response) {
  //   if (response && response.data && response.data.disclaimerInfo && response.data.disclaimerInfo.component) {
  //     const termsOfUseInfo = response.data.disclaimerInfo.component.disclaimer;
  //     commonStore.termsOfUse.content = termsOfUseInfo;
  //   }
  // }

  render() {
    return <Layout />;
  }
}

export default App;
